import {mobile} from "codemirror/src/util/browser";

global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;


import {gsap} from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { CustomEase } from "gsap/CustomEase";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { SplitText } from "gsap/SplitText";
import { Flip } from "gsap/Flip";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(Flip);

import Lenis from 'lenis';

import Headroom from "headroom.js";



import AOS from 'aos';
import 'aos/dist/aos.css';


// import Swiper from 'swiper/bundle';
// import 'swiper/swiper-bundle.css';
// import { Navigation, Pagination } from 'swiper/modules';
function horizontalLoop(items, config) {

    function isMobile() {
        return window.innerWidth < 1200 || screen.width < 1200;
    }

    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1),
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    gsap.set(items, {
        xPercent: (i, el) => {
            let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    gsap.set(items, {x: 0});
    totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
        item = items[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
    }
    return tl;
}
$(document).ready(function() {

    // To-top button
    // const toTopBtn = $('#to-top');
    // $(window).scroll(function(){
    //     if ($(window).scrollTop() > 300) {
    //         toTopBtn.fadeIn();
    //     } else {
    //         toTopBtn.fadeOut();
    //     }
    // });
    //
    // toTopBtn.on('click', function (e) {
    //     e.preventDefault();
    //     $('html, body').animate({
    //         scrollTop: 0
    //     }, 'slow');
    // });

    gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase, DrawSVGPlugin);
    ScrollTrigger.config({ ignoreMobileResize: true });

    if ($('.headroom').length > 0) {
        let headroomEl = document.querySelector("header");
        let options = {
            offset: 100,
        }
        let headroom = new Headroom(headroomEl, options);
        headroom.init();
    }

    // Initialize a new Lenis instance for smooth scrolling
    const lenis = new Lenis({
        duration: 1.2,        // durata dello scroll (più alto = più morbido)
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easing esponenziale
        smoothWheel: true,
        wheelMultiplier: 1,   // sensibilità rotella
        touchMultiplier: 1,   // sensibilità touch
        prevent: (node) => !!node.closest('#cc-main'),
    })

    // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
    lenis.on('scroll', ScrollTrigger.update);

    // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
    // This ensures Lenis's smooth scroll animation updates on each GSAP tick
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); // Convert time from seconds to milliseconds
    });

    // Disable lag smoothing in GSAP to prevent any delay in scroll animations
    gsap.ticker.lagSmoothing(0);

    window.lenis = lenis;

    ScrollTrigger.addEventListener("refreshInit", () => lenis.stop());
    ScrollTrigger.addEventListener("refresh", () => lenis.start());

    /* fine smoothscroll */


    //menu opener
    const open = document.querySelector('.burger');
    const close = document.querySelector('.close');
    let tlMenu = gsap.timeline({ defaults: { duration: 0.7, ease: 'power1.inOut' } });
    open.addEventListener('click', () => {
        lenis.stop()
        tlMenu.timeScale(1.5); // reset velocità normale
        if (tlMenu.reversed()) {
            tlMenu.play();
        } else {
            // stop scroll
            // parte animazione
            tlMenu.to('.menuContainer', { right: 0 })
                .to('.menuContainer', { height: '100vh' }, '-=.1')
                .to('.subMenu', { opacity: 1 }, '-=1')
                .to('.menuContainer .subMain .mainItem', { opacity: 1, pointerEvents: 'all', stagger: 0.2 }, '-=.8')
                .to('.close', { opacity: 1, pointerEvents: 'all' }, "-=.8");
        }
    });

    close.addEventListener('click', () => {
        tlMenu.timeScale(2).reverse(); // 1.5x più veloce in chiusura
        lenis.start()
    });

    let subOpeners = $('.subOpener');
    function isMobile() {
        const minWidth = 1200; // Minimum width for desktop devices
        return window.innerWidth < minWidth || screen.width < minWidth;
    }
    if (!isMobile()){
        $(subOpeners).on('mouseenter', function() {
            let wrap = $(this).find('.nav-submenu-wrapper');

            wrap[0].style.width = 'max-content';
            const targetWidth = wrap[0].offsetWidth;
            wrap[0].style.width = '0';

            $(this).data('tl', gsap.timeline({ defaults: { duration: 0.5, ease: 'expo.inOut' } })
                .to(wrap, { opacity: 1 })
                .to(wrap, { width: targetWidth }, '-=.1')
            );
        });

        $(subOpeners).on('mouseleave', function() {
            $(this).removeClass('open');
            $(this).data('tl').reverse();
        });
    } else {
        $(subOpeners).on('touchstart', function(e) {
            e.stopPropagation();
            let wrap = $(this).find('.nav-submenu-wrapper');
            if (!$(this).hasClass('open')) {
                $(this).addClass('open');
                wrap.stop().slideDown();
            } else {
                $(this).removeClass('open');
                wrap.stop().slideUp();
            }

        });
    }

    if (!$('.active_content_editor')[0]){
        if ($('.pinned-section')[0]){
            document.querySelectorAll('.pinned-section').forEach((section) => {
                const textEl = section.querySelector('.splitAnimation');
                const split = new SplitText(textEl, { type: 'words' });
                gsap.set(split.words, { opacity: 0, y: 10 });

                const mobile = isMobile();

                const wordsTl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top 20%',
                        end: mobile ? 'top -60%' : 'top -130%',
                        scrub: true,
                    }
                });
                wordsTl.to(split.words, {
                    opacity: 1,
                    y: 0,
                    duration: 0.30,
                    ease: 'power2.out',
                    stagger: 0.12,
                });

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: section,
                        start: 'top top',
                        end: mobile ? '+=100%' : '+=130%',
                        pin: true,
                        scrub: mobile ? 0.3 : 0.8,
                        anticipatePin: 1,
                    }
                });

                const shapePath   = section.querySelector('#shape-path');
                const shapeStroke = section.querySelector('#shape-stroke');

                if (shapePath) {
                    const svg = section.querySelector('#shape-svg');

                    // Su mobile il viewport è più alto in proporzione alla larghezza,
                    // quindi serve un valore di risalita maggiore
                    const svgHeight = (window.innerHeight / window.innerWidth) * 1440;
                    const riseTarget = mobile ? -(svgHeight + 180 + 100) : -820;

                    if (svg) {
                        svg.setAttribute('viewBox', `0 ${riseTarget} 1440 ${Math.abs(riseTarget) + 180}`);
                    }

                    const shapeState = { tip: 0, sides: 180 };

                    const updateShape = () => {
                        const t = shapeState.tip;
                        const s = shapeState.sides;
                        shapePath.setAttribute('d',
                            `M 0,180 L 0,${s} L 720,${t} L 1440,${s} L 1440,180 Z`
                        );
                        if (shapeStroke) {
                            shapeStroke.setAttribute('d', `M 0,${s} L 720,${t} L 1440,${s}`);
                            shapeStroke.setAttribute('opacity', (0.6 * (s / 180)).toFixed(3));
                        }
                    };

                    updateShape();

                    tl.to(shapeState, {
                        tip: riseTarget,
                        sides: riseTarget,
                        ease: 'linear',
                        duration: 3,
                        onUpdate: updateShape,
                    }, 0.6);
                }
            });
        }
    }

    function animateMenu() {
        let menu = $('.anim-menu');
        if (menu.length > 0) {
            let leftItem = $('.anim-menu-left');
            let rightItem = $('.anim-menu-right');
            // let middleItem = $('.anim-menu-middle');

            let menuAnime = gsap.timeline({})
            menuAnime
                .to(leftItem,  { translateX: '0', opacity:1, duration: 1.4, ease: 'power1.out' }, 0)
                .to(rightItem, { translateX: '0', opacity:1, duration: 1.4, ease: 'power1.out'}, 0)
        }
    }

    function animateTextHero(splitTitle,splitSubTitle,splitDesc) {
        // splitDesc
        let titAnime = gsap.timeline({})
        titAnime.to(splitTitle.words, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            ease: 'power2.out',
            stagger: 0.3,
            delay: 1,
        }, 0).to(splitSubTitle.words, {
            opacity: 1,
            y: 0,
            duration: 0.4,
            ease: 'power2.out',
            stagger: 0.2,
            delay: 1,
        }, 1).to(splitDesc.words, {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'power2.out',
            stagger: 0.1,
            delay: 1,
        }, 1);
    }

    if ($(".loader").length > 0 ) {

        let loaderTl = gsap.timeline();

        let splitTitle = null;
        let splitSubTitle = null;
        let splitDesc = null;
        let exSplitTitle = null;

        if (!$('.active_content_editor')[0]){
            let title = $('[data-id="homeHeroTile"] h1');
            let subtitle = $('[data-id="homeHeroSubTile"] h2');
            let desc = $('[data-id="homeHeroDesc"] h4');
            let exTitle = $('.titleToAnim h1');

            if (title[0]){
                splitTitle = new SplitText(title, { type: 'words' });
                splitSubTitle = new SplitText(subtitle, { type: 'words' });
                splitDesc = new SplitText(desc, { type: 'words' });

                gsap.set(splitTitle.words, { opacity: 0, y: 30 });
                gsap.set(splitSubTitle.words, { opacity: 0, y: 20 });
                gsap.set(splitDesc.words, { opacity: 0, y: 10 });
            }

            if (exTitle[0]){
                exSplitTitle = new SplitText(exTitle, { type: 'words' });
                gsap.set(exSplitTitle.words, { opacity: 0, y: 30 });

            }

        }


        loaderTl.to(".loader-mask", {
                x: "100%",
                duration: 1,
                ease: "power3.inOut",
            },"-=0.4")
            .to(".loader",{
                opacity: 0,
                duration: 0.4,
                ease: "power4.inOut",
                onComplete: () => {
                    $(".loader").remove();
                    //IMPORTANTE!!!!!!!!!
                    /* se ci sono delle animazioni che devono partire dopo che il loader ha finito di animarsi, mettere la timeline qua*/
                    // NB: il ?. è un controllo automatico/if se la variabile è definita o meno

                    //Tutte le animazioni con classe masked-text devono partire dopo che il loader ha finito di animarsi
                    if (!$('.active_content_editor')[0]) {
                        // Prima registra il CustomEase (una volta sola)

                        if (isMobile()){
                            if ($('.maschera-mobile')[0]){
                                CustomEase.create("maskIn", "0.16, 1, 0.3, 1");

                                gsap.fromTo(
                                    $('.maschera-mobile'),
                                    {
                                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"  // rettangolo pieno = copre tutto
                                    },
                                    {
                                        clipPath: "polygon(0% 0%, 25% 0%, 0% 100%, 0% 100%)",    // triangolo sottile a sinistra = quasi invisibile
                                        duration: 2,
                                        ease: "maskIn",
                                        delay: 0,
                                        immediateRender: true
                                    }
                                );
                            }
                        } else {
                            if ($('.maschera')[0]){
                                CustomEase.create("maskIn", "0.16, 1, 0.3, 1");

                                gsap.fromTo(
                                    $('.maschera'),
                                    {
                                        // opacity: 1,
                                        clipPath: "polygon(100% 100%, 0% 100%, 0% 100%, 0% 0%, 0% 0%, 0% 100%, 0% 100%, 0% 0%, 100% 0%, 100% 100%, 100% 100%)"
                                    },
                                    {
                                        // opacity: 1,
                                        clipPath: "polygon(101% 101%, 0% 101%, 20.31% 101%, 20.31% 0%, 24.51% 0%, 24.51% 101%, 45.38% 101%, 32.23% 0%, 63.45% 0%, 50.33% 101%, 101% 101%)",
                                        duration: 2,
                                        ease: "maskIn",
                                        delay: 0,
                                        immediateRender: true
                                    }
                                );
                            }
                        }

                        if ($('.servizi-mask')[0]){
                            CustomEase.create("maskIn", "0.16, 1, 0.3, 1");

                            gsap.fromTo(
                                $('.servizi-mask'),
                                {
                                    clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)"  // rettangolo pieno = copre tutto
                                },
                                {
                                    clipPath: "polygon(0% 0%, 25% 0%, 0% 100%, 0% 100%)",    // triangolo sottile a sinistra = quasi invisibile
                                    duration: 2,
                                    ease: "maskIn",
                                    delay: 0,
                                    immediateRender: true
                                }
                            );
                        }

                        if ($('.titleToAnim h1')[0]){

                            let exTitAnime = gsap.timeline({})

                            exTitAnime.to(exSplitTitle.words, {
                                opacity: 1,
                                y: 0,
                                duration: 0.8,
                                ease: 'power2.out',
                                stagger: 0.3,
                                delay: 0,
                            })
                        }

                        if ($('.page-home')[0]){
                            animateMenu()
                            animateTextHero(splitTitle,splitSubTitle,splitDesc)
                        }



                        if ($('.splitText')[0]){
                            gsap.set(".splitText", { opacity: 1 });

                            document.querySelectorAll(".splitText").forEach((el) => {
                                SplitText.create(el, {
                                    type: "words,lines",
                                    linesClass: "line",
                                    autoSplit: true,
                                    mask: "lines",
                                    onSplit: (self) => {
                                        return gsap.from(self.lines, {
                                            duration: 0.6,
                                            yPercent: 100,
                                            opacity: 0,
                                            stagger: 0.1,
                                            ease: 'power2.out',
                                            scrollTrigger: {
                                                trigger: el,
                                                start: "top 60%",
                                                toggleActions: "play none none none",
                                            },
                                        });
                                    }
                                });
                            });

                            // ← dopo aver creato tutti i SplitText e i loro trigger
                            requestAnimationFrame(() => {
                                ScrollTrigger.refresh();
                            });
                        }
                    }
                }
            });
    }

    if ($('.magazine-marquee')[0]) {
        // duplica il contenuto finché non supera la larghezza dello schermo
        const marquee = document.querySelector('.magazine-marquee');
        const originalHTML = marquee.innerHTML;
        while (marquee.offsetWidth < window.innerWidth * 3) {
            marquee.innerHTML += originalHTML;
        }

        horizontalLoop(".magazine-marquee h3, .magazine-marquee .separator", {
            repeat: -1,
            paddingRight: 40,
            speed: 0.5,
        });
    }

    // SCROLL TO NEXT SECTION
    // Il pulsante
    const btn = document.querySelector('#next-section-btn');
    if (btn){
        btn.addEventListener('click', () => {
            const sections = document.querySelectorAll('section');
            const scrollY = lenis.scroll; // usa lenis.scroll invece di window.scrollY

            let nextSection = null;
            let nextSectionStart = Infinity;

            for (const section of sections) {
                // Cerca se questa section ha uno ScrollTrigger associato
                const st = ScrollTrigger.getAll().find(
                    (trigger) => trigger.trigger === section || trigger.pin === section
                );

                // Se ha un ST, usa il suo "start" reale nello scroll space
                const sectionStart = st ? st.start : section.offsetTop;

                if (sectionStart > scrollY + 10 && sectionStart < nextSectionStart) {
                    nextSectionStart = sectionStart;
                    nextSection = st ? st.trigger : section;
                }
            }

            if (nextSection) {
                lenis.scrollTo(nextSectionStart, {
                    duration: 1.4,
                    easing: (t) => 1 - Math.pow(1 - t, 4),
                });
            }
        });
    }


    lenis.on('scroll', () => {
        document.querySelectorAll('.iframe-wrapper').forEach(wrap => {
            wrap.classList.add('is-scrolling');
        });
        clearTimeout(window._lenisIframeTimer);
        window._lenisIframeTimer = setTimeout(() => {
            document.querySelectorAll('.iframe-wrapper').forEach(wrap => {
                wrap.classList.remove('is-scrolling');
            });
        }, 150);
    });



    // if ($('.enter-row').length) {
    //     gsap.utils.toArray(".enter-row").forEach((row) => {
    //         gsap.from(row, {
    //             x: -80,
    //             opacity: 0,
    //             duration: 1,
    //             ease: "power2.out",
    //             scrollTrigger: {
    //                 trigger: row,
    //                 start: "top 90%",   // 30% dal top = 70% dell'altezza dello schermo
    //                 toggleActions: "play none none reset",
    //             },
    //         });
    //     });
    // }

    if (isMobile()){
        let mobileFooterOpener = $('#mobileFooterOpener')
        let footerInfos = $('#footerInfos')

        mobileFooterOpener.click(function (e) {
            e.preventDefault()
            if (mobileFooterOpener.hasClass('open')) {
                footerInfos.stop().slideUp(300);
                mobileFooterOpener.removeClass('open')
            } else {
                footerInfos.stop().slideDown(300);
                mobileFooterOpener.addClass('open')
                let n = $(document).height();
                // console.log(n)
                $('html, body').animate({scrollTop: n}, 200);
            }
        })
    }

    let img_g = $('.img_g');
    let cont = $('.container_img_g');
    if (img_g[0]){

        const startScale = isMobile() ? 0.5 : 0.7;
        const contEl = cont[0];
        const contHeight = contEl.offsetHeight;
        const viewH = window.innerHeight;

        let imgTl = gsap.timeline({
            scrollTrigger: {
                trigger: cont,
                scrub: 1,
                pin: false,
                start: 'top',
                end: 'bottom bottom',
                ease: "linear",
            }
        });

        imgTl.fromTo(img_g, {
            scale: startScale,
            ease: 'none'
        }, {
            scale: '1',
            ease: 'none'
        });
    }


    // let img_g = $('.img_g');
    // let cont = $('.container_img_g');
    //
    // if (img_g[0]) {
    //     const startScale = isMobile() ? 0.5 : 0.7;
    //
    //     // Calcola un end dinamico basato sull'altezza del container
    //     const contEl = cont[0];
    //     const contHeight = contEl.offsetHeight;
    //     const viewH = window.innerHeight;
    //
    //     // Se il container è basso (img orizzontale), estendiamo il range di scrub
    //     const dynamicEnd = Math.max(contHeight, viewH * 0.5);
    //
    //     let imgTl = gsap.timeline({
    //         scrollTrigger: {
    //             trigger: cont,
    //             scrub: 1,
    //             pin: false,
    //             start: 'top',
    //             end: () => `+=${dynamicEnd}`,
    //             ease: "none",
    //         }
    //     });
    //
    //     imgTl.fromTo(img_g,
    //         { scale: startScale, ease: 'none' },
    //         { scale: 1,          ease: 'none' }
    //     );
    // }

    // gallery
    if ($('.gallery-wrap')[0]){
        let flipCtx;

        const createTween = () => {
            let galleryElement = document.querySelector("#gallery-8");
            let galleryItems = galleryElement.querySelectorAll(".gallery__item");

            flipCtx && flipCtx.revert();
            galleryElement.classList.remove("gallery--final");

            flipCtx = gsap.context(() => {
                // Temporarily add the final class to capture the final state
                galleryElement.classList.add("gallery--final");
                const flipState = Flip.getState(galleryItems);
                galleryElement.classList.remove("gallery--final");

                const flip = Flip.to(flipState, {
                    simple: true,
                    ease: "expoScale(1, 5)"
                });

                const tl = gsap.timeline({
                    scrollTrigger: {
                        trigger: galleryElement,
                        start: "center center",
                        end: "+=100%",
                        scrub: true,
                        pin: galleryElement.parentNode
                        // markers: true
                    }
                });
                tl.add(flip);
                return () => gsap.set(galleryItems, { clearProps: "all" });
            });
        };
        createTween();

        window.addEventListener("resize", createTween);
    }

    if ($('.reveal')[0]) {
        const tlImg = gsap.timeline();

        let revealContainers = document.querySelectorAll(".reveal");

        revealContainers.forEach((container) => {
            let image = container.querySelector(".img-animate");
            let tlImg = gsap.timeline({
                paused: true,
                scrollTrigger: {
                    trigger: container,
                    // markers: true,
                    start: "top 80%",
                    toggleActions: "play none none none"
                }
            });

            tlImg.set(container, { autoAlpha: 1 });
            tlImg.from(container, 1, {
                xPercent: -100,
                ease: 'Power2.out'
            });
            tlImg.from(image, 1, {
                xPercent: 100,
                scale: 1.3,
                delay: -1,
                ease: 'Power2.out'
            });
        });
    }

});

window.addEventListener("load", () => {
    ScrollTrigger.refresh();

    if ($('.enter-row').length) {
        gsap.utils.toArray(".enter-row").forEach((row) => {
            gsap.from(row, {
                x: -80,
                opacity: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: row,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            });
        });
    }
});
